export const RESET_ADMIN = 'reset_admin'
